module.exports = __webpack_public_path__ + "img/q_img01.b849f930.jpg";